// extracted by mini-css-extract-plugin
export default {"lastTradedContainer":"LastTradedValues_lastTradedContainer__vgaKT"};